declare let require: any;

import { ICellAdapter } from "./ICellAdapter";

import { ColumnDefinition } from "../model/ColumnDefinition";

import { IndexType } from "../model/IndexType";

// Get Long + BigNumber from CubiqTS for instanceof to work with ConcreteEncodable
import * as CubiqTS from "shared/cubiq-model-multi-asset";

export class DateAdapter implements ICellAdapter {
  localeString: string = "DD-MMM-YY HH:mm:ss";
  constructor(format?: string) {
    if (format && typeof format == "string") {
      this.localeString = format;
    }
  }

  adapt(column: ColumnDefinition, row: any, ...modelObjects: any[]): void {
    row[column.data] = this.retrieveData(modelObjects[0], column.data);
    row[column.sortKey] = this.retrieveSort(modelObjects[0], column.data);
    row[column.filterKey] = this.retrieveFilter(modelObjects[0], column.data);
    if (column.hasSearchKey) {
      row[column.searchKey] = this.retrieveSearch(modelObjects[0], column.data);
    }
  }

  getDate(adaptee: any, columnProperty: string): CubiqTS.Moment {
    let dt: any = adaptee[columnProperty];
    if (CubiqTS.moment.isMoment(dt)) {
      // TODO: offset conditions with TZ are lost over subjects
      // this reapplies tz offset conditions on a fresh moment instance
      return dt.utc().local();
    } else if (CubiqTS.Long.isLong(dt)) {
      // moment accepts unix milliseconds seconds in this format
      let dtM = CubiqTS.moment((dt as CubiqTS.Long).toNumber());
      return dtM;
    } else if (typeof dt === "string") {
      // FIXME: Cubiq-TS decode ISO string to moment
      // iso string from CUBIQTS miss decode
      // let dtM = moment(dt, "YYYY-MM-DD HH:mm:ss");

      let dtM = CubiqTS.moment(Number(dt));

      // TODO tz support- cubiq-ts is always UTC
      return dtM;
    } else if (dt && dt.toLocaleDateString) {
      return CubiqTS.moment(dt);
    } else if (dt && CubiqTS.moment.isMoment(dt)) {
      return dt;
    } else if (dt instanceof CubiqTS.StandardDateImpl) {
      return CubiqTS.moment.tz([dt.year, dt.month - 1, dt.day], "UTC");
    }
    return null;
  }

  retrieveData(order: any, columnProperty: string): string {
    let moment: CubiqTS.Moment = this.getDate(order, columnProperty);
    // TODO i18n
    if (moment) {
      return moment.utc().format(this.localeString);
    }
    return "-";
  }

  retrieveSort(order: any, columnProperty: string): number {
    let moment: CubiqTS.Moment = this.getDate(order, columnProperty);
    if (moment) {
      return moment.valueOf();
    }
    return -1;
  }

  retrieveSearch(order: any, columnProperty: string): string {
    return this.retrieveData(order, columnProperty);
  }

  retrieveFilter(order: any, columnProperty: string): string {
    let moment: CubiqTS.Moment = this.getDate(order, columnProperty);
    return moment != null ? moment.valueOf() + "" : null;
  }
}
